import * as types from '../_actions/actionTypes'
import _ from 'lodash'

export function sms(state = {}, action) {
    switch (action.type) {
        case types.SEND_SMS:
            return {
                type: 'success',
                data: action.payload.data,
            }
        case types.SEND_SMS_FAILURE:
            return {
                type: 'failed',
                message: action.message,
            }
        case types.STATS_SMS:
            return {
                type: 'stats-success',
                data: action.payload.data,
            }
        case types.STATS_SMS_FAILURE:
            return {
                type: 'stats-failed',
                message: action.message,
            }
        default:
            return state
    }
}
